import {Component} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {SlideLeft, SlideRight} from 'src/app/Util/AnimationUtil';
import {ReserveListPanelController} from './ReserveListPanelController';
import {BasePanelComponent} from '../../../../../BaseUI/BasePanel';
import {ReservationListDTOInterface} from '../../../../../../DTO/ReservationListDTOInterface';

/**
 * ReserveListPanelComponent
 */
@Component({
	selector: 'ReserveListPanelComponent',
	templateUrl: './ReserveListPanelComponent.html',
	styleUrls: ['./ReserveListPanelComponent.scss'],
	animations: [
		SlideLeft,
		SlideRight
	]
})

export class ReserveListPanelComponent extends BasePanelComponent {

	// コンポーネントを操作するコントローラー
	public combineCtrl: ReserveListPanelController;

	public eventShowDetail: (reserveId: number) => void;

	// 現在の予約一覧(アクセス時よりreservation_toが未来の予約)
	public validReserveList: Array<ReservationListDTOInterface> = [];
	// 過去の予約(アクセス時よりreservation_toが過去の予約)
	public inValidReserveList: Array<ReservationListDTOInterface> = [];

	/**
	 * constructor
	 * @param dialogCtrl ダイアログコントローラ
	 */
	constructor(
		public dialogCtrl: MatDialog // ダイアログ機能
	) {
		// Angularのコンポーネントなので上位を呼ぶ。
		super();
		// BaseViewでコントローラのインスタンスを作成して保持する（ロジック系はコントローラに実装する）
		this.createController(ReserveListPanelController);
	}

	/**
	 * start
	 * 開始処理
	 */
	public async start() {


		// データ取得/リスト設定。失敗したらエラーなので、後続処理はやらない。
		if (!this.setupDateList()) {
			return;
		}

	}

	/**
	 * updateList
	 * リストを取得して設定。アップデートする
	 */
	public async setupDateList(): Promise<boolean> {

		// データ取得
		const data = await this.execFuncWithErrorHandling(
			this,
			await this.combineCtrl.getReservationList.bind(this),
			{view: this}
		);
		if (!data) {
			return false;
		}

		this.validReserveList = data.valid;
		this.inValidReserveList = data.inValid;

		return true;
	}

	/**
	 * showDetail
	 * 詳細ダイアログの表示 Detailコンポーネントに引き渡す
	 * @param data
	 */
	public async showDetail(data: ReservationListDTOInterface) {

		await this.eventShowDetail(data.id);

	}

	/**
	 * onClickListRow
	 * 行をクリックしたときのイベント
	 * @param row
	 */
	public async onClickReservation(row: ReservationListDTOInterface) {
		await this.eventShowDetail(row.id);
	}

}
